
function   updateHeaderOpacity(activeMenu /* may be null */) {
    const header = document.querySelector('.header-wrapper');
    const menus  = Array.from(document.querySelectorAll('header-menu'));
    const anyOpen = menus.some(m => m.mainDetailsToggle?.hasAttribute('open'));

    
    if (anyOpen) {
      header.classList.add('header--dim');
      const active = activeMenu && activeMenu.mainDetailsToggle?.hasAttribute('open')
        ? activeMenu
        : menus.find(m => m.mainDetailsToggle?.hasAttribute('open'));
      menus.forEach(m => m.classList.toggle('is-active', m === active));
      
    } else {
      header.classList.remove('header--dim');
      menus.forEach(m => m.classList.remove('is-active'));
    }
  }
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    


    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
      
    } else {
      this.animations.forEach((animation) => animation.cancel());      
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

  }
 onToggle() {
    if (!this.header) return;
    const menus  = Array.from(document.querySelectorAll('header-menu'));
    const anyOpen = menus.some(m => m.mainDetailsToggle?.hasAttribute('open'));

    if (this.mainDetailsToggle.hasAttribute('open')) {
        updateHeaderOpacity(this)
      document.querySelectorAll('header-menu').forEach(menu => {
      
        if (menu !== this && menu.mainDetailsToggle.hasAttribute("open")) {
          
          menu.close();
           const ll =  menu.content;
              ll.style.opacity = '0'; 

        } else if(menu == this) {
           const el = this.content;
              el.style.opacity = '1';  
                          
        } else {
           menu.close();
             const ll =  menu.content;
              ll.style.opacity = '0'; 
        }
      });
      console.log();
      
      document.querySelector(".menu__desktop__bg-overlay").style.height = `${this.header.offsetHeight + this.content.offsetHeight}px`
    } else {
        updateHeaderOpacity(null)

      if (anyOpen) {
          this.close();
           const el = this.content;
          el.style.opacity = '0';
        return
      }; 
      document.querySelector(".menu__desktop__bg-overlay").style.height = "0"
           this.close();
          const el = this.content;          
          el.style.opacity = '0';
    }
  }



  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    const el = this.content;
      el.style.opacity = '0';
  }
}

customElements.define('header-menu', HeaderMenu);
